import React from 'react';
import CategoryCards from 'components/revelo-ui/content/category-cards';

const CategoryCardsTastic = ({ data }) => {
  return <CategoryCards cards={data.cards} />;
};

export default CategoryCardsTastic;
